module.exports = __webpack_public_path__ + "static/media/Icon awesome-user-tie-gris.0058dbee.svg";